// lading statuses
export const ORDER_SCOPE: string[] = [
    "Tradeshow",
    "Storage",
    "Trailer Build",
    "Warehouse",
    "Household",
    "Plug Play",
    "Blanketed",
    "Dock to Dock",
    "White Glove",
    "Military Site",
    "Extraction",
    "Disposal",
    "Job Site"
];

export const SERVICE_CHARGES: string[] = [
    'Accessorial Service',
    'Surcharge Service',
    'Tradeshow Service',
    'Trailer Build Service',
    'Customs Service',
    'Delivery Service',
    'Pickup Service',
    'Labourer Service'
]